import NewsRssLink from "./news-rss-link.vue";

window.Vue.createApp({
    components: {
        NewsRssLink,
    },
}).mount("#news-rss-link");
